import { render } from "./LocatorSubView.vue?vue&type=template&id=15b3db34&scoped=true&ts=true"
import script from "./LocatorSubView.vue?vue&type=script&lang=ts"
export * from "./LocatorSubView.vue?vue&type=script&lang=ts"

import "./LocatorSubView.vue?vue&type=style&index=0&id=15b3db34&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b3db34"]])

export default __exports__